// extracted by mini-css-extract-plugin
export default {"tecanTransferStationViz":"tecanTransferStationViz-WPIVY","row":"row-GxS3t","cell":"cell-HkbcC"};